import React, {useState, useEffect} from 'react';
import {StyledCross} from "../SideDrop/TabsSideDropdown/tabsDropStyles";
import {OutlinedInput} from "../Inputs/inputsStyles";
import {GreenButton} from "../Buttons/buttonsStyles";
import BasedModal from "../BaseModalComponents/BasedModal";
import {addTab} from "../../store/reducers/TabsSlice";
import {useDispatch} from "react-redux";
import {Styles} from "react-modal";
import notifySuccess from 'utils/Notifications/Success';

interface IProps {
    isModalOpen: boolean
    closeModal: () => void
    customStyle: Styles
}

function CreateTabModal({isModalOpen, closeModal, customStyle}: IProps) {
    const dispatch = useDispatch()
    const [tabName, setTabName] = useState("")

    const handleTabCreateClick = () => {
        dispatch(addTab({name: tabName}));
        closeModal();
    };

    useEffect(() => {
        if (!isModalOpen && tabName) {
            setTabName('');
        }
    }, [isModalOpen]);

    return (
        <BasedModal
            isOpen={isModalOpen}
            onRequestClose={closeModal}
            style={customStyle}
        >
            <h3 id="modal_create-tab" style={{position: 'relative'}}>
                Введите имя новой вкладки
                <StyledCross onClick={closeModal}/>
            </h3>
            <OutlinedInput value={tabName} onChange={e => setTabName(e.target.value)}/>
            <GreenButton onClick={handleTabCreateClick}>
                Сохранить
            </GreenButton>
        </BasedModal>
    );
}

export default CreateTabModal;
